import { chartStyles } from '../common/common-chart-utils/common-chart-styles';

export const pieChartStyles = () => {
  return {
    ...chartStyles(),
  };
};
